exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.application__row td[data-v-06cfad8f] {\n    min-width: 150px;\n}\n.application__row .address[data-v-06cfad8f] {\n    min-width: 300px;\n}\n.table-responsiv[data-v-06cfad8f] {\n    overflow-y: hidden;\n}\n\n", ""]);

// exports
